export class ProductOptionModel {
    public name: string;
}